import {
  Box,
  Button,
  Heading,
  List,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import useBrokerLogo from 'hooks/modules/brokerAccount/useBrokerLogo';
import useBrokerName from 'hooks/modules/brokerAccount/useBrokerName';
import { BrokerAccountItem } from 'model/modules/profile/profile';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

import ConnectedBrokerAccountListItem from 'presentation/components/modules/brokerAccount/connected_list/ConnectedBrokerAccountListItem';
import AppCard from 'presentation/components/shared/card/AppCard';
import DeleteBrokerAccountModal from 'presentation/containers/modules/brokerAccount/DeleteBrokerAccountModal';
import { useUpdateEffect } from 'react-use';

interface Props {
  items: BrokerAccountItem[];
}

const BrokerAccountListLoadedContainer: FC<Props> = ({ items }) => {
  const getBrokerName = useBrokerName();
  const getBrokerLogo = useBrokerLogo();

  const [deletingAccountId, setDeletingAccountId] = useState<ID | null>(null);

  const { isOpen, onClose, onOpen } = useDisclosure();

  const { t } = useTranslation();

  const navigate = useNavigate();

  useUpdateEffect(() => {
    if (!isOpen) {
      setDeletingAccountId(null);
    }
  }, [isOpen]);

  let listNode;
  if (items.length > 0) {
    listNode = (
      <List width="100%">
        {items.map((item, index) => {
          return (
            <Box mb="20px" key={index}>
              <ConnectedBrokerAccountListItem
                name={getBrokerName(item.brokerType)}
                logo={getBrokerLogo({ brokerType: item.brokerType })}
                status={item.status}
                accountNumber={item.account}
                onDeleteClick={(e) => {
                  e.stopPropagation();
                  setDeletingAccountId(item.id);
                  onOpen();
                }}
              />
            </Box>
          );
        })}
      </List>
    );
  } else {
    listNode = (
      <AppCard p="40px" mb="20px">
        <Text textAlign="center">{t('listIsEmpty')}</Text>
      </AppCard>
    );
  }

  return (
    <>
      {listNode}
      <AppCard p="40px">
        <Heading mb="20px" fontSize="20px" as="h4">
          {t('newAccountTitle')}
        </Heading>
        <Text mb="20px" fontWeight={600}>
          {t('newAccountText')}
        </Text>
        <Button
          onClick={() => {
            navigate(AppRoute.createBrokerAccount);
          }}
        >
          {t('connect')}
        </Button>
      </AppCard>
      {deletingAccountId && (
        <DeleteBrokerAccountModal
          isOpen={isOpen}
          onClose={onClose}
          accountId={deletingAccountId}
        />
      )}
    </>
  );
};

export default BrokerAccountListLoadedContainer;
